import { logLoginApi } from '@core/core/api'
import type { AppThunk } from '@core/core/store'
import { getAllProjects, getCompanies, getFields, getProjectTypes } from '@core/core/store'

import { userSlice } from './userSlice'
export const { setUserInfo, userLogout } = userSlice.actions

export const userLogin = (): AppThunk => async dispatch => {
  await logLoginApi()

  dispatch(getAllProjects())
  dispatch(getCompanies())
  dispatch(getFields())
  dispatch(getProjectTypes())
}
